var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27997 3.22C4.13779 3.08752 3.94975 3.0154 3.75545 3.01882C3.56114 3.02225 3.37576 3.10096 3.23835 3.23838C3.10093 3.37579 3.02222 3.56118 3.01879 3.75548C3.01537 3.94978 3.08749 4.13782 3.21997 4.28L4.93997 6L3.21997 7.72C3.08749 7.86217 3.01537 8.05022 3.01879 8.24452C3.02222 8.43882 3.10093 8.62421 3.23835 8.76162C3.37576 8.89903 3.56114 8.97775 3.75545 8.98117C3.94975 8.9846 4.13779 8.91248 4.27997 8.78L5.99997 7.06L7.71997 8.78C7.86214 8.91248 8.05019 8.9846 8.24449 8.98117C8.43879 8.97775 8.62418 8.89903 8.76159 8.76162C8.899 8.62421 8.97772 8.43882 8.98114 8.24452C8.98457 8.05022 8.91245 7.86217 8.77997 7.72L7.05997 6L8.77997 4.28C8.91245 4.13782 8.98457 3.94978 8.98114 3.75548C8.97772 3.56118 8.899 3.37579 8.76159 3.23838C8.62418 3.10096 8.43879 3.02225 8.24449 3.01882C8.05019 3.0154 7.86214 3.08752 7.71997 3.22L5.99997 4.94L4.27997 3.22Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCategory);
export default __webpack_public_path__ + "static/media/RemoveCategory.3c85ade5c7a03211f6362f3e85c07699.svg";
export { ForwardRef as ReactComponent };